module.exports = __webpack_public_path__ + "img/506.623bd126.png";